<template>
	<div class="tpl appointment-mine-wrap">
		<mt-header title="约会详情" fixed>
		  <router-link :to="{name:fromPath.name}" slot="left">
		    <mt-button icon="back"></mt-button>
		  </router-link>
		  <mt-button class="add-friend-btn"  icon="more" slot="right" @click.native="moreMenu=!moreMenu"></mt-button>
		</mt-header>
		<div class="user-info">
			<div class="user-img">
				<img :src="appointmentInfo.r_img||appointmentInfo.avatar"/>
			</div>
			<div class="user-text">
				<p class="user-name">
					{{appointmentInfo.nickname}}  {{appointmentInfo.age}}岁  
					<img v-if="appointmentInfo.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
					<img v-if="appointmentInfo.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
				</p>
				<p class="user-sig">{{appointmentInfo.Message || "此用户很懒，没有约会寄语"}}</p>
			</div>
		</div>
		<div class="appointment-option">
			<div class="option option-premoney">
				<div class="option-show">
					<span class="name">诚意金</span>
					<span class="value">{{appointmentInfo.earnest_money==0?"没有诚意金":"有诚意金"}}</span>
				</div>
				<button v-if="appointmentInfo.earnest_money==0" @click="addPremoneyShow=1">补充诚意金</button>
			</div>
			<div class="option option-gift">
				<div class="option-show">
					<span class="name">礼物</span>
					<span class="value">{{ appointmentInfo.gift&&appointmentInfo.gift.length<=0?"没有礼物":"有礼物"}}</span>
				</div>
				<button v-if="appointmentInfo.gift&&appointmentInfo.gift.length<=0" @click="addGift(appointmentInfo.r_id)">补充礼物</button>
			</div>
		</div>
		<div class="appointment-info">
			<ul>
				<li><img src="../../assets/img/finds/ic_find_detail_theme@2x.png" alt="" /><p>{{appointmentInfo.name}}</p></li>
				<li><img src="../../assets/img/finds/ic_find_detail_time@2x.png" alt="" /><p>{{appointmentInfo.release_time | toDateTime | convertTime("MM/DD HH:MM")}}</p></li>
				<li><img src="../../assets/img/finds/ic_find_detail_position@2x.png" alt="" /><p>{{appointmentInfo.region_name}}</p></li>
				<li>
					<img src="../../assets/img/finds/ic_find_detail_contype@2x.png" alt="" />
					<p>
						<span v-if="appointmentInfo.consumption_type==0">AA制</span>
						<span v-if="appointmentInfo.consumption_type==1">我买单</span>
						<span v-if="appointmentInfo.consumption_type==2">你买单</span>
					</p>
				</li>
				<li>
					<img src="../../assets/img/finds/ic_find_detail_sex@2x.png" alt="" />
					<p>
						<span v-if="appointmentInfo.girl_friend==0">性别不限</span>
						<span v-if="appointmentInfo.girl_friend==1">限男生</span>
						<span v-if="appointmentInfo.girl_friend==2">限女生</span>
					</p>
				</li>
				<li><img src="../../assets/img/finds/ic_find_detail_number@2x.png" alt="" /><p>1人</p></li>
				<li v-if="appointmentInfo.gift" v-for="item in appointmentInfo.gift">
					<img :src="item.girft_img_url" alt="" />
					<p>{{item.girft_name}}*{{item.g_nums}}</p>
				</li>
			</ul>
		</div>
		<div class="appointment-joins">
			<p class="title"><span>应约人数</span><span v-if="appointmentInfo.sign">{{appointmentInfo.sign.length}} 人</span></p>
			<ul v-if="appointmentInfo.sign">
				<li v-for="item in appointmentInfo.sign">
					<div class="join-user-info">
						<div class="user-img">
							<img :src="item.avatar"/>
						</div>
						<div class="user-text">
							<p class="user-name">{{item.nickname}}</p>
							<p class="user-age">
								{{item.age}}岁 
								<img v-if="item.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
								<img v-if="item.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/></p>
						</div>
					</div>
					<div class="item-btns">
						<button @click="appointmentOption(1)">同意</button>
						<button @click="appointmentOption(2)">再考虑</button>
					</div>
				</li>
			</ul>
		</div>
		<mt-actionsheet :actions="moreActions" v-model="moreMenu"> </mt-actionsheet>
		<div class="upper-wrap premoney-box" v-if="addPremoneyShow">
			<div class="upper-inner premoney-inner">
				<p class="title">补充诚意金</p>
				<div class="money-list upper-content">
					<span v-for="item in premoneyList" :class="{'active':item==choosedPremoney}" @click="choosedPremoney=item">{{item}}桃花币</span>
				</div>
				<div class="upper-btns premoney-btns">
					<button class="sure" @click="addPremoneyShow=0;payPremoneyShow=1">确定</button>
				</div>
			</div>
		</div>
		<div class="upper-wrap premoney-box" v-if="payPremoneyShow">
			<div class="upper-inner premoney-inner">
				<p class="title">支付诚意金</p>
				<div class="pay-content upper-content">
					<div class="pay-num">
						<span class="num">{{choosedPremoney	}}</span>
						<span class="per">桃花币</span>
					</div>
					<div class="pay-type">
						<span class="name">约会诚意金</span>
						<span class="value">账户支付</span>
					</div>
				</div>
				<div class="upper-btns pay-btns">
					<button class="cancel" @click="payPremoneyShow=0">取消</button>
					<button class="sure" @click="payPremoney">确定</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"appointment-mine",
		data(){
			return{
				uid:"",
				aId:"",	//当前约会id
				fromPath:"",	//来源路由
				appointmentInfo:"",
				moreMenu:false,
				moreActions:[
					{name:"删除约会",method:this.deleteAppointment}
				],
				addPremoneyShow:0,
				payPremoneyShow:0,
				premoneyList:[10,20,50,80,200,500],
				choosedPremoney:500,
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed","finds");		//属于finds模块
			this.$store.commit("changeTabBarShow",false);	//不显示navbar
			
			this.aId = this.$route.query.id;
			this.getAppointmentInfo();
		},
		
		beforeRouteEnter (to, from, next) {
            next((vm)=>{ //参数vm就是当前组件的实例。
                vm.fromPath = from;
                console.log(vm.fromPath)
            })
		},
		methods:{
			getAppointmentInfo(){
				this.$axios({
					url:"Appointment/MyAppointmentDetails",
					method:"post",
					data:{
						r_id:this.aId
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.appointmentInfo = res.data.data;
						console.log(this.appointmentInfo)
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			deleteAppointment(){
				if(this.appointmentInfo.uid==this.uid){
					this.$axios({
						url:"Appointment/DeleteAppointment",
						method:"post",
						data:{
							r_id:this.appointmentInfo.r_id,
						}
					}).then(res=>{
						console.log(res);
						this.$toast({
								message:res.data.msg,
								position:"bottom",
								duration:3000
							})
						if(res.data.code==200){
							
							this.$router.push({
								name:this.fromPath.name
							})
						}
					}).catch(err=>{
						console.log(err)
					})
				}else{
					this.$toast({
						message:"你只能删除你自己的约会哦~",
						position:"bottom",
						duration:3000
					})
				}
			},
			appointmentOption(s){
				if(this.appointmentInfo.uid==this.uid){
					this.$axios({
						url:"Appointment/agreeInvi",
						method:"post",
						data:{
							r_d_id:this.appointmentInfo.r_id,
							status:s
						}
					}).then(res=>{
						console.log(res);
						if(res.data.code==200){
							this.$toast({
								message:res.data.msg,
								position:"bottom",
								duration:3000
							})
							this.getAppointmentInfo();
						}
					}).catch(err=>{
						console.log(err)
					})
				}else{
					this.$toast({
						message:"你只能取消你自己的约会哦~",
						position:"bottom",
						duration:3000
					})
				}
			},
			addGift(id){
				this.$router.push({
					name:"add-gift",
					query:{
						id:id
					}
				})
			},
			payPremoney(){
				console.log(this.aId,this.choosedPremoney);
				this.$axios({
					url:"Appointment/fund",
					method:"post",
					data:{
						uid:this.uid,
						r_id:this.aId,
						money:this.choosedPremoney
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.$toast({
							message:res.data.msg,
							position:"bottom",
							duration:3000
						});
						this.payPremoneyShow=0;
						this.getAppointmentInfo();
					}
				}).catch(err=>{
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped>
	.appointment-mine-wrap{
		padding-top: 2.5rem;
		background: #fff;
	}
	>>>.mintui-more{
		color: #5415F9;
	}
	.user-info{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0.5rem 1rem;
		border-bottom: 1px solid #f3f3f3;
	}
	.user-info .user-img img{
		width: 4rem;
		display: block;
		border-radius: 5px;
	}
	.user-info .user-text{
		padding: 0 0.5rem;
	}
	.user-info .user-name{
		flex: 1;
		font-size: 1rem;
		line-height: 2rem;
		font-weight: bold;
		color: #282828;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.user-info .user-name img{
		width: 1.5rem;
	}
	.user-info .user-sig{
		font-size: 0.8rem;
		line-height: 1.5rem;
		color: #9e9e9e;
	}
	.appointment-option{
		
	}
	.appointment-option .option{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 1rem;
		border-bottom: 1px solid #f3f3f3;
	}
	.appointment-option .option-show{
		flex: 1;
	}
	.appointment-option .option .name{
		font-size: 0.8rem;
		color: #282828;
		width: 5rem;
		display: inline-block;
	}
	.appointment-option .option .value{
		font-size: 0.8rem;
		color: #fe908f;
	}
	.appointment-option .option button{
	    background: #fe908f;
	    border: 0;
	    outline: 0;
	    color: #fff;
	    padding: 0.4rem 1rem;
	    border-radius: 3px;
	    width: 7rem;
	}
	.appointment-option .option button:active{
		opacity: 0.7;
	}
	.appointment-info{
		border-bottom: 1px solid #f3f3f3;
	}
	.appointment-info ul{
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.appointment-info ul li{
		width: 25%;
		text-align: center;
		border-right: 1px solid #f3f3f3;
		margin: 1rem 0;
		font-size: 0.8rem;
		color: #282828;
	}
	.appointment-info ul li img{
	    width: 2rem;
	    display: inline-block;
	    margin-bottom: 0.6rem;
	}
	.appointment-joins .title{
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 1rem;
		padding: 1rem;
		border-top: 0.5rem solid #f3f3f3;
		border-bottom: 1px solid #f3f3f3;
	}
	.appointment-joins ul li{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 1rem;
		border-bottom: 1px solid #f3f3f3;
	}
	.appointment-joins .user-img img{
		width: 4rem;
		border-radius: 5px;
		display: block;
	}
	.appointment-joins .join-user-info{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.appointment-joins .user-text{
		padding: 0 0.5rem;
	}
	.appointment-joins .user-name{
		font-size: 1rem;
		line-height: 2rem;
		color: #282828;
		font-weight: bold;
	}
	.appointment-joins .user-age{
		font-size: 0.8rem;
		color: #282828;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.appointment-joins .user-age img{
		width: 1.5rem;
	}
	.appointment-joins .item-btns button{
		border: 1px solid #ccc;
	    background: none;
	    outline: 0;
	    padding: 0.3rem 1rem;
	    border-radius: 2rem;
	    font-size: 0.8rem;
	    color: #282828;
	}
	.appointment-joins .item-btns button:active{
		background: #f3f3f3;
	}
	
	
	.upper-wrap{
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10;
		display: flex;
		justify-content: flex-end;
		flex-direction: column;
		align-items: center;
		background: rgba(0,0,0,.3);
	}
	.upper-inner{
		background: #fff;
		border-radius: 1rem 1rem 0 0;
		width: 100%;
	}
	.upper-inner .title{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		text-align: center;
		padding: 0.5rem;
		border-bottom: 1px solid #f3f3f3;
	}
	.upper-content{
		min-height: 15rem;
	}
	.upper-content.money-list{
		padding: 1rem;
	}
	.upper-content.money-list span{
		box-sizing: border-box;
		background: #f3f3f3;
		color: #7b7b7b;
		padding: 0.35rem 1rem;
		display: inline-block;
		margin: 0.5rem 0.2rem;
		font-size: 0.8rem;
		border-radius: 2rem;
		text-align: center;
		width: 30%;	
		border: 1px solid transparent;
	}
	.upper-content.money-list span.active{
		border: 1px solid #5415F9;
		color: #5415F9;
		background: rgba(84,21,249,.1);
	}
	.upper-inner .upper-btns{
		padding: 1.5rem 1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.upper-inner .upper-btns button{
		width: 45%;
		height: 2.3rem;
		border-radius: 3px;
		outline: 0;
	}
	.upper-inner .upper-btns button.cancel{
		border: 1px solid #f3f3f3;
		color: #7b7b7b;
		background: none;
	}
	.upper-inner .upper-btns button.sure{
		color: #fff;
		background:linear-gradient(90deg,rgba(84,21,249,0.7) 0%,rgba(84,21,249,0.3) 100%);
		border: 0;
	}
	.upper-inner .premoney-btns button.sure{
		width: 100%;
	}
	.pay-content{
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		text-align: center;
		padding-top: 1rem;
	}
	.pay-content .pay-num .num{
		font-size: 2.5rem;
		color: #FF6161;
	}
	.pay-content .pay-num .per{
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.pay-content .pay-type{
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 1rem;
		color: #7b7b7b;
		padding: 0.5rem 1rem;
		border-top: 1px solid #f3f3f3;
		border-bottom: 1px solid #f3f3f3;
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/AppointmentMine.vue